module.exports = {
    new:'new',
    time:'time:',
    watch: 'detail',
    hotlook: 'hot',
    looknum: 'number：',
    detail: 'detail',
    diary: 'diary',
    lookall: 'detail',
    live: 'To Born，To Live',
    friendlink:'Friendly Link',
    grassortree:'GRASS OR TREE',
    shouce:'Online Manual',
    publish: 'time',
    clicknum: 'number',
    comment: 'Comment',
    comment_r1: 'Please enter comments',
    comment_r2: 'Comments is betweent 5 and 50',
    comment_content: 'Content',
    required:'require',
    name:'Name',
    name_req:'Please enter name',
    name_r1:'Please enter name',
    name_r2:'Name is betweent 3 and 15',
    email:'Email',
    email_r1:'Please enter email',
    email_r2:'Please enter email',
    email_req:'Please enter email',
    follow:'Be strictly compliance with laws and regulations!O(∩_∩)O',
    list:'Comment List',
    reset:'reset',
    submit:'comment',
    toobig:'too big',
    toosmall:'too small',
    detail_ok:'comment success',
    detail_fail:'comment fail',
    noempty:'not empty',
    notsearch: 'Too many search, please try again later!',
    index:'HOME',
    it:'IT ARTICLE',
    diary: 'DIARY',
    nodata:'no data！',
    recommend:'Recommend',

    test:'Test',
    search:'search',
    input:'Please input contents',
    select:'select',
    articletitle:'title',
    articlecon:'content',
    know:'Examination notes ',
    begintest:'begin',
    giveanswer:'submit',
    endtest:'end',
    retest:'Take the exam again',
    noanswer:'NOT NULL',
    selecttype:'Please select',
    oneright:'Only one right',
    noright:'Must have a right answer',
    noquestion:'NOT NULL',
    questiontype:'Please select',
    lookanswer:'Do you mind giving a question to check your answers?',
    givequestion:'Give a question',
    lookgrade:'Only marks',
    istest:'Are you begin the test?',
    conformtest:'test',
    thinkabout:'Think ahead',
    testtitle:'test?',
    cancletest:'Little by little one goes far',
    giveanswers:'Are you give a answer?',
    conformgive:'submit',
    submitanswer:'submit',
    miss:'miss',
    threetofive:'At least 3 to 5 answers',
    submitok:'Think you for your question',
    submitfail:'submit fail',
    leastfive:'At most 5 answers',
    useemail:'Send your email',
    question:'question',
    questionstatus:'Question type',
    other:'other',
    thank:'Think you for your question!',
    answerlist:'answer',
    rightanswer:'right answer',
    wronganswer:'wrong answer',
    submitquestion:'submit',
    addquestion:'add answer',
    del:'delete',

    me:' ME ',
    about:'Me',
    use:'USE',
    contact:'CONTACT',
    home:'Home',
    mail:'Email',
    common:{
        neterror:'Network Anomaly',
        back:'back',
        loading:'loading...',
        button:'It is over',
        detail:'For more details',
        home:'Home',
        current:'location',
        more:'detail',
        zan:'Thank you for the compliment!',
        zaned:'You have already praised me!',
        submit:'submit',
        wechat:'wechat'

    }
}



//////////////////
// WEBPACK FOOTER
// ./lang/en.js
// module id = n8F9
// module chunks = 1